export const runAfterDomLoad = (func: () => void): void => {
  document.addEventListener('DOMContentLoaded', func);
};
